export default __webpack_public_path__ + "static/media/image-14.43934846.png";